'use strict';

// A "once" utility.
module.exports = function(fn) {
  var result, called = false;
  return function() {
    if (!called) {
      called = true;
      result = fn.apply(this, arguments);
    }
    return result;
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/httpplease/lib/utils/once.js
// module id = 264
// module chunks = 4